import EditorialBoard from "../../components/Board/EditorialBoard";

export default function EditorialBoardPage() {
  return <EditorialBoard />;
}
